import { useMemo } from 'react';
import { Control } from 'react-hook-form';
import { components as SelectComponents, OptionProps } from 'react-select';
import { StatusCodes } from '../../../../../v2/js/constants/workflows';
import { type ConnectedFacility } from '../../../../api';

import { SelectController } from '../../SelectController';
import './FacilitySelector.scss';

type FacilityOption = {
  label: string;
  value: string;
  isAwaitPriv: boolean;
};

const AwaitPrivOption = (props: OptionProps<FacilityOption>) => (
  <SelectComponents.Option {...props}>
    {props.data.label}
    {props.data.isAwaitPriv && (
      <span className="facility-selector__badge">Awaiting Privileges</span>
    )}
  </SelectComponents.Option>
);

interface FacilitySelectorProps {
  connectedFacilities: ConnectedFacility[];
  onChange: (selection: { value: string; label: string }) => void;
  control: Control<Record<string, any>>;
  name: string;
}

export const FacilitySelector = ({
  connectedFacilities,
  onChange,
  control,
  name,
}: FacilitySelectorProps) => {
  const options = useMemo(() => {
    return connectedFacilities.map((relationship) => ({
      label: relationship.facility.name ?? '',
      value: relationship.facility.id,
      isAwaitPriv: relationship.current_status?.code === StatusCodes.AWAIT_PRVLG,
    }));
  }, [connectedFacilities]);

  return (
    <SelectController
      control={control}
      name={name}
      options={options}
      isMulti={false}
      isClearable={true}
      placeholder="Choose Assignment Facility"
      onChange={onChange}
      returnOnlyValue={false}
      components={{ Option: AwaitPrivOption }}
    />
  );
};
